// translate router.meta.title, be used in breadcrumb sidebar tagsview
// export function generateTitle(title) {
//   const hasKey = this.$te('route.' + title)
//
//   if (hasKey) {
//     // $t :this method from vue-i18n, inject in @/lang/index.js
//     const translatedTitle = this.$t('route.' + title)
//
//     return translatedTitle
//   }
//   return title
// }
import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// 以下为语言包单独设置的场景，单独设置时语言包需单独引入
const messages = {
  'zh_HK': require('../lang/zh'),   // 繁体中文语言包
  'en_US': require('../lang/en')    // 英文语言包
}
// 最后 export default，这一步肯定要写的。
export default new VueI18n({
  locale : localStorage.getItem('lang')|| 'en_US', // set locale 默认显示繁体
  messages : messages, // set locale messages
  silentTranslationWarn: true
})




// WEBPACK FOOTER //
// ./src/utils/i18n.js